import { eventChannel } from 'redux-saga';
import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import { LOGIN_SUCCESS, LOGOUT } from '../Login/constants';
import { selectCurrentUser } from '../Login/selectors';
import { closePusher, setupPusher } from '../services/pusher';
import { showBadge } from '../Push/badge';
import { showNotice } from './actions';
import { gameMoved } from '../NewMoves/actions';

/**
 * The signed-in player's own channel: the server's game notices (GameNotices), the same ones it sends by push,
 * shown as a banner while the app is open (someone already looking at that game sees the move happen instead); and
 * every move the other player makes in your games (GameMoved), for the count of new moves.
 */
function* listenTask() {
  const user = yield select(selectCurrentUser);
  const echo = yield call(setupPusher);
  const name = `App.User.${user.get('id')}`;
  const notices = eventChannel((emit) => {
    echo.private(name)
      .listen('GameNotice', ({ message }) => emit({ notice: message }))
      .listen('GameMoved', (moved) => emit({ moved }));
    return () => echo.leave(name);
  });

  try {
    while (true) {
      const { notice, moved } = yield take(notices);
      if (moved) {
        yield put(gameMoved(moved));
        continue;
      }
      yield call(showBadge, notice.badge);
      if (window.location.pathname !== notice.url) {
        yield put(showNotice(notice));
      }
    }
  } finally {
    notices.close();
  }
}

// A new sign-in starts listening again; signing out stops it and closes the connection.
function* listenOrStopTask(action) {
  if (action.type === LOGOUT) {
    yield call(closePusher);
    return;
  }
  yield call(listenTask);
}

export default [
  function* noticesWatcher() { yield takeLatest([LOGIN_SUCCESS, LOGOUT], listenOrStopTask); },
];
